// extracted by mini-css-extract-plugin
export default {"wrapperStakeInfo":"StakeInfo_wrapperStakeInfo__tRNiL","title":"StakeInfo_title__59psV","value":"StakeInfo_value__5buJg"};